import { bindMethod } from './chunk-QF7HVQZZ.js';

// src/pointer.ts
var PointerMove = class {
  constructor(config = {}) {
    this.cb = config.cb ?? (() => {
    });
    this.el = config.el ? typeof config.el === "string" ? document.querySelector(config.el) ?? document : config.el : document;
    bindMethod(this, ["run"]);
    this.run = this._run.bind(this);
  }
  on() {
    this.el.addEventListener("pointermove", this.run, {
      passive: false
    });
  }
  off() {
    this.el.removeEventListener("pointermove", this.run);
  }
  _run(e) {
    this.cb(e.pageX, e.pageY, e);
  }
};

export { PointerMove };
//# sourceMappingURL=chunk-RFHEQMFJ.js.map
//# sourceMappingURL=chunk-RFHEQMFJ.js.map